import React from 'react';
import {
  FiCompass,
  FiTarget,
  FiClipboard,
  FiTrendingUp,
  FiBarChart2,
  FiUsers,
} from 'react-icons/fi';
import {
  Main,
  MaxWidth,
  Title,
  Heading,
  Sub,
  Grid,
  Card,
  IconWrap,
  CardTitle,
  CardText,
} from './BusinessSkills.elements';

const ITEMS = [
  {
    icon: FiCompass,
    title: 'Product Management',
    text: 'Owning product roadmap, feature prioritization and system architecture decisions as Co-Founder at Nailing.ai.',
  },
  {
    icon: FiTarget,
    title: 'Problem Solving',
    text: 'Structured problem-solving from the McKinsey Forward program, applied to taking products from zero to production.',
  },
  {
    icon: FiClipboard,
    title: 'Project Management',
    text: 'Cross-functional delivery across multiple startups; coordinated operations for 224 delegates from 56 countries at MOIC 2022.',
  },
  {
    icon: FiTrendingUp,
    title: 'Digital Marketing & Analytics',
    text: 'Google Analytics certified. Built content, hook-optimization and competitor-analysis modules for short-form growth.',
  },
  {
    icon: FiBarChart2,
    title: 'Business Analysis',
    text: 'Business Analyst at AVIDEF — requirements, corporate documentation and operational structuring for an Aerospace & Defense firm.',
  },
  {
    icon: FiUsers,
    title: 'Leadership & Communication',
    text: 'Co-founded teams and clubs, prepared investor-facing material at 4Ps Networks, and trained in 21st-century competencies (YetGen).',
  },
];

const reveal = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: 0.07 * i, ease: 'easeOut' },
  }),
};

function BusinessSkills() {
  return (
    <Main id="business">
      <MaxWidth>
        <Title variants={reveal} initial="hidden" animate="visible">
          Beyond code
        </Title>
        <Heading variants={reveal} custom={1} initial="hidden" animate="visible">
          Business &amp; Product
        </Heading>
        <Sub variants={reveal} custom={2} initial="hidden" animate="visible">
          A Business Administration &amp; MIS background paired with hands-on
          engineering — I build products with a strategy-first mindset.
        </Sub>

        <Grid>
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <Card
                key={it.title}
                variants={reveal}
                custom={i + 1}
                initial="hidden"
                animate="visible"
              >
                <IconWrap>
                  <Icon />
                </IconWrap>
                <CardTitle>{it.title}</CardTitle>
                <CardText>{it.text}</CardText>
              </Card>
            );
          })}
        </Grid>
      </MaxWidth>
    </Main>
  );
}

export default BusinessSkills;
